(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["alex-welcome-offer"] && !Shopify.designMode) return;
  try {
    (function(){
  const dialog=document.getElementById('alex-welcome-offer');
  if(!dialog||typeof dialog.showModal!=='function')return;
  const key='alex-welcome-offer-v1';
  try{if(sessionStorage.getItem(key))return;}catch{}
  const open=()=>{
    if(document.querySelector('dialog[open]'))return;
    dialog.showModal();
    try{sessionStorage.setItem(key,'1');}catch{}
  };
  const schedule=()=>window.setTimeout(open,1200);
  if(document.readyState==='complete')schedule();
  else window.addEventListener('load',schedule,{once:true});
  dialog.addEventListener('click',event=>{
    if(event.target!==dialog)return;
    const rect=dialog.getBoundingClientRect();
    if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dialog.close();
  });
})();
  } catch(e) { console.error(e); }
})();

})();
